module.exports = __webpack_public_path__ + "static/media/correct-1.f571a700.m4a";